import { AirlineCard, AirlineDesc, AirlineLogo, AirlineName } from './style'

export const AirlineCardComponent = ({ flightInfo }) => {
	return (
		<AirlineCard href={flightInfo.href}>
			<AirlineLogo src={flightInfo.imageUrl} alt={flightInfo.name} />
			<AirlineName>{flightInfo.name}</AirlineName>
			<AirlineDesc>{flightInfo.desc}</AirlineDesc>
		</AirlineCard>
	)
}